export interface Agent {
  id: string;
  name: string;
  role: string;
  rating: number;
  color: string;
  profileUrl?: string;
}

export interface DepartmentData {
  id: string;
  name: string;
  color: string;
  bgColor: string;
  agents: Agent[];
}

export const DEPARTMENTS: Record<string, DepartmentData> = {
  HR: {
    id: "HR",
    name: "HR",
    color: "#3b82f6",
    bgColor: "rgba(59, 130, 246, 0.1)",
    agents: [
      { id: "hirplix", name: "Hirplix", role: "HR & People Ops", rating: 5.0, color: "#3b82f6", profileUrl: "/ai/hr-people-ops" },
    ],
  },
  "Finance & Accounting": {
    id: "Finance & Accounting",
    name: "Finance & Accounting",
    color: "#22c55e",
    bgColor: "rgba(34, 197, 94, 0.1)",
    agents: [
      { id: "finplix", name: "Finplix", role: "Finance & Accounting", rating: 5.0, color: "#22c55e", profileUrl: "/ai/finance-accounting" },
    ],
  },
  Sales: {
    id: "Sales",
    name: "Sales",
    color: "#f59e0b",
    bgColor: "rgba(245, 158, 11, 0.1)",
    agents: [
      { id: "salesplix", name: "Salesplix", role: "Sales & Revenue", rating: 5.0, color: "#f59e0b", profileUrl: "/ai/sales-revenue" },
    ],
  },
  Marketing: {
    id: "Marketing",
    name: "Marketing",
    color: "#8b5cf6",
    bgColor: "rgba(139, 92, 246, 0.1)",
    agents: [
      { id: "markplix", name: "Markplix", role: "Marketing & Growth", rating: 5.0, color: "#8b5cf6", profileUrl: "/ai/marketing-growth" },
    ],
  },
  IT: {
    id: "IT",
    name: "IT",
    color: "#06b6d4",
    bgColor: "rgba(6, 182, 212, 0.1)",
    agents: [
      { id: "techplix", name: "Techplix", role: "IT & Technology", rating: 5.0, color: "#06b6d4", profileUrl: "/ai/it-technology" },
    ],
  },
  Legal: {
    id: "Legal",
    name: "Legal",
    color: "#64748b",
    bgColor: "rgba(100, 116, 139, 0.1)",
    agents: [
      { id: "lawplix", name: "Lawplix", role: "Legal & Compliance", rating: 5.0, color: "#64748b", profileUrl: "/ai/legal-compliance" },
    ],
  },
  Operations: {
    id: "Operations",
    name: "Operations",
    color: "#f97316",
    bgColor: "rgba(249, 115, 22, 0.1)",
    agents: [
      { id: "opsplix", name: "Opsplix", role: "Operations", rating: 5.0, color: "#f97316", profileUrl: "/ai/operations" },
    ],
  },
  "Customer Support": {
    id: "Customer Support",
    name: "Customer Support",
    color: "#ec4899",
    bgColor: "rgba(236, 72, 153, 0.1)",
    agents: [
      { id: "cxplix", name: "Cxplix", role: "Customer Support", rating: 5.0, color: "#ec4899", profileUrl: "/ai/customer-support" },
    ],
  },
  "Consultation & Advisory": {
    id: "Consultation & Advisory",
    name: "Consultation & Advisory",
    color: "#b45309",
    bgColor: "rgba(180, 83, 9, 0.08)",
    agents: [
      { id: "advplix", name: "Advplix", role: "Consultation & Advisory", rating: 5.0, color: "#b45309", profileUrl: "/ai/consultation-advisory" },
    ],
  },
  "Full Stack & App Dev": {
    id: "Full Stack & App Dev",
    name: "Full Stack & App Dev",
    color: "#6366f1",
    bgColor: "rgba(99, 102, 241, 0.1)",
    agents: [
      { id: "devplix", name: "Devplix", role: "Full Stack & App Dev", rating: 5.0, color: "#6366f1", profileUrl: "/ai/full-stack-app-dev" },
    ],
  },
  "Data & Analytics": {
    id: "Data & Analytics",
    name: "Data & Analytics",
    color: "#0ea5e9",
    bgColor: "rgba(14,165,233,0.1)",
    agents: [
      { id: "dataplix", name: "Dataplix", role: "Data & Analytics", rating: 5.0, color: "#0ea5e9", profileUrl: "/ai/data-analytics" },
    ],
  },
  "Executive Office": {
    id: "Executive Office",
    name: "Executive Office",
    color: "#8b5cf6",
    bgColor: "rgba(139,92,246,0.1)",
    agents: [
      { id: "execplix", name: "Execplix", role: "Executive Assistant", rating: 5.0, color: "#8b5cf6", profileUrl: "/ai/executive-assistant" },
    ],
  },
  "Supply Chain & Procurement": {
    id: "Supply Chain & Procurement",
    name: "Supply Chain & Procurement",
    color: "#f97316",
    bgColor: "rgba(249,115,22,0.1)",
    agents: [
      { id: "chainplix", name: "Chainplix", role: "Supply Chain & Procurement", rating: 5.0, color: "#f97316", profileUrl: "/ai/supply-chain-procurement" },
    ],
  },
  "Real Estate": {
    id: "Real Estate",
    name: "Real Estate",
    color: "#14b8a6",
    bgColor: "rgba(20,184,166,0.1)",
    agents: [
      { id: "propplix", name: "Propplix", role: "Real Estate", rating: 5.0, color: "#14b8a6", profileUrl: "/ai/real-estate" },
    ],
  },
  "Healthcare & Medical": {
    id: "Healthcare & Medical",
    name: "Healthcare & Medical",
    color: "#ec4899",
    bgColor: "rgba(236,72,153,0.1)",
    agents: [
      { id: "medplix", name: "Medplix", role: "Healthcare & Medical", rating: 5.0, color: "#ec4899", profileUrl: "/ai/healthcare-medical" },
    ],
  },
  "E-Commerce": {
    id: "E-Commerce",
    name: "E-Commerce",
    color: "#f59e0b",
    bgColor: "rgba(245,158,11,0.1)",
    agents: [
      { id: "shoplix", name: "Shoplix", role: "E-Commerce", rating: 5.0, color: "#f59e0b", profileUrl: "/ai/e-commerce" },
    ],
  },
  Manufacturing: {
    id: "Manufacturing",
    name: "Manufacturing",
    color: "#6b7280",
    bgColor: "rgba(107,114,128,0.1)",
    agents: [
      { id: "manuplix", name: "Manuplix", role: "Manufacturing", rating: 5.0, color: "#6b7280", profileUrl: "/ai/manufacturing" },
    ],
  },
  "Strategy Consulting": {
    id: "Strategy Consulting",
    name: "Strategy Consulting",
    color: "#1d4ed8",
    bgColor: "rgba(29,78,216,0.1)",
    agents: [
      { id: "stratplix", name: "Stratplix", role: "Strategy Consulting", rating: 5.0, color: "#1d4ed8", profileUrl: "/ai/strategy-consulting" },
    ],
  },
  "Tax Advisory": {
    id: "Tax Advisory",
    name: "Tax Advisory",
    color: "#15803d",
    bgColor: "rgba(21,128,61,0.1)",
    agents: [
      { id: "taxplix", name: "Taxplix", role: "Tax Advisory", rating: 5.0, color: "#15803d", profileUrl: "/ai/tax-advisory" },
    ],
  },
  "Audit & Risk": {
    id: "Audit & Risk",
    name: "Audit & Risk",
    color: "#7c2d12",
    bgColor: "rgba(124,45,18,0.1)",
    agents: [
      { id: "auditplix", name: "Auditplix", role: "Audit & Risk", rating: 5.0, color: "#7c2d12", profileUrl: "/ai/audit-risk" },
    ],
  },
  "Business Transformation": {
    id: "Business Transformation",
    name: "Business Transformation",
    color: "#6d28d9",
    bgColor: "rgba(109,40,217,0.1)",
    agents: [
      { id: "transplix", name: "Transplix", role: "Business Transformation", rating: 5.0, color: "#6d28d9", profileUrl: "/ai/business-transformation" },
    ],
  },
};

export const DEPARTMENT_TYPES = Object.keys(DEPARTMENTS);
